

import { 
    Container,
} from "react-bootstrap";
import PDFPage8Table1 from "./pdf-page-8/PDFPage8Table1";
import PDFPage8Table2 from "./pdf-page-8/PDFPage8Table2";
import PDFPage8Table3 from "./pdf-page-8/PDFPage8Table3";
import PDFPage8Table4 from "./pdf-page-8/PDFPage8Table4";

function PDFPage8(props: any) {

    let shareholderTotalData:any = {};

    if(props?.shareholderData?.getMoreThanTenPercentTotalData && props?.shareholderData?.getMoreThanOneApartmentTotalData){
        shareholderTotalData.total_car_spaces = 
        props?.shareholderData?.getMoreThanTenPercentTotalData?.total_car_spaces + props?.shareholderData?.getMoreThanOneApartmentTotalData?.total_car_spaces;

        shareholderTotalData.total_no_of_apartments = 
        props?.shareholderData?.getMoreThanTenPercentTotalData?.total_no_of_apartments + props?.shareholderData?.getMoreThanOneApartmentTotalData?.total_no_of_apartments


        shareholderTotalData.total_other_spaces = 
        props?.shareholderData?.getMoreThanTenPercentTotalData?.total_other_spaces + props?.shareholderData?.getMoreThanOneApartmentTotalData?.total_other_spaces;

        shareholderTotalData.total_percentage_of_shares = 
        parseFloat(props?.shareholderData?.getMoreThanTenPercentTotalData?.total_percentage_of_shares?.replace(',', '.')?.replace(' %', ''))
        + 
        parseFloat(props?.shareholderData?.getMoreThanOneApartmentTotalData?.total_percentage_of_shares?.replace(',', '.')?.replace(' %', ''));


        shareholderTotalData.total_percentage_of_shares = shareholderTotalData.total_percentage_of_shares?.toString().replace('.', ',')+" %";
    }

    return (
        <>
            <Container fluid className="text-left page-break cu-pt-10">
                <h3 className="cu-fs-18">{props.TranslateString("Osakeanalyysi (1/2)")}​ ​</h3>
                <PDFPage8Table1  {...props} data={props?.shareholderData?.getAllData?.apartments}/>
                <PDFPage8Table2  {...props} data={props?.shareholderData?.getAllData?.carspaces} 
                otherSpace={props?.shareholderData?.getAllData?.otherspaces}/>
                <PDFPage8Table3  {...props} data={[...props?.shareholderData?.getMoreThanTenPercentData || [],...props?.shareholderData?.getMoreThanOneApartmentData || []]}
                //   total={{...props?.shareholderData?.getMoreThanTenPercentTotalData || {}, ...props?.shareholderData?.getMoreThanOneApartmentTotalData || {}}}
                  total={shareholderTotalData}
                  />
            </Container>
            <Container fluid className={ props?.loanPriority && props?.loanPriority == '13' ? "text-left cu-pt-10" : "text-left page-break cu-pt-10"}>
                <h3 className="cu-fs-18">{props.TranslateString("Osakeanalyysi (2/2)")}​ ​</h3>
                <PDFPage8Table4  {...props} data={props?.shareholderData?.getCompanyShareholderData} total={props?.shareholderData?.getCompanyShareholderTotalData }/>
            </Container>
        </>
    );
}

export default PDFPage8;